import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Authme, handleLogin, showToast } from '../Utils/utils';
import "./Style.css"
import Loader from '../../Component/Loader/Loader';
import { connect, useDispatch } from 'react-redux';
import { UserData } from '../Redux/action/UserSession';


const Login = (props) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();

  const Loginauth = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      let isEmail = username.includes("@");
      let response = await handleLogin({
        username: isEmail ? username : username,
        password,
      });
      localStorage.setItem("token", response.data.access_token);
      showToast(response.message, "success");
      dispatch(UserData())
      // if (response.data.user?.role === 'hospital_provider') {
      //   console.log("jhiiooo")
      //   navigate('/survey-dashboard');
      // } else {
      //   navigate('/dashboard');
      // }
    } catch (error) {
      console.log(error, "error...");
      setLoading(false)
      showToast(error.message || "Login failed", "error");
    } finally {
      setLoading(false)
    }
  };


  useEffect(() => {

    if (localStorage.getItem('token') !== null) {
      if (props?.userdata?.role == 'hospital_provider') {
        window.location.href = "/survey-dashboard"
      } else {
        window.location.href = "/dashboard"
      }
    }
  }, [props])


  return (
    <>
      {loading && <Loader />}
      <div className="page-top">

        <div className="page-wrapper mx-auto px-4">
          <div className='mt-5'>

            <div className='d-flex justify-content-between'>
              <h3 className='provider-title'>Welcome Provider!</h3>
              {/* <Link to="/dashboard" style={{ textDecoration: 'none' }}> */}
              <img className='img-fluid' src="/Images/logo.svg" alt="logo image" />
              {/* </Link> */}

            </div>

            <h6 className='login-title mt-2'>Log in to Elderly</h6>
          </div>
          <form className='form mt-3' onSubmit={Loginauth}>
            <div className='email d-flex flex-column gap-2'>
              <label className='email-label'>Email/Service ID</label>
              <input className='emailinput ' type='text' onChange={(e) => setUsername(e.target.value)} value={username} placeholder='Enter your email' />
            </div>
            <div className='email d-flex flex-column gap-2 mt-3'>
              <label className='email-label'>Password</label>
              <input className='emailinput ' type='password' onChange={(e) => setPassword(e.target.value)} value={password} placeholder='Enter your password' />
            </div>
            <div className='submitbtn-res d-sm-block d-lg-none d-md-none'>
              <button className='continue-btn-res mt-2' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
            <div className='submitbtn-wrapper d-lg-block d-md-block d-xl-block d-xxl-block d-sm-none'>
              <button className='continue-btn mt-3' type='submit'>
                <span className='continuebtn-text'>Continue</span>
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  )
}
const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);